export const VENTA_NACIONAL = '01'
export const COMPRA_NACIONAL = '02'
export const CONSIGNACIÓN_RECIBIDA = '03'
export const CONSIGNACIÓN_ENTREGADA = '04'
export const DEVOLUCIÓN_RECIBIDA = '05'
export const DEVOLUCIÓN_ENTREGADA = '06'
export const BONIFICACIÓN = '07'
export const PREMIO = '08'
export const DONACIÓN = '09'
export const SALIDA_A_PRODUCCIÓN = '10'
export const SALIDA_POR_TRANSFERENCIA_ENTRE_ALMACENES = '11'
export const RETIRO = '12'
export const MERMAS = '13'
export const DESMEDROS = '14'
export const DESTRUCCIÓN = '15'
export const SALDO_INICIAL = '16'
export const EXPORTACIÓN = '17'
export const IMPORTACIÓN = '18'
export const ENTRADA_DE_PRODUCCIÓN = '19'
export const ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN = '20'
export const ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES = '21'
export const ENTRADA_POR_IDENTIFICACIÓN_ERRONEA = '22'
export const SALIDA_POR_IDENTIFICACIÓN_ERRONEA = '23'
export const ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE = '24'
export const SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR = '25'
export const ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN = '26'
export const SALIDA_POR_SERVICIO_DE_PRODUCCIÓN = '27'
export const AJUSTE_POR_DIFERENCIA_DE_INVENTARIO = '28'
export const ENTRADA_DE_BIENES_EN_PRÉSTAMO = '29'
export const SALIDA_DE_BIENES_EN_PRÉSTAMO = '30'
export const ENTRADA_DE_BIENES_EN_CUSTODIA = '31'
export const SALIDA_DE_BIENES_EN_CUSTODIA = '32'
export const MUESTRAS_MÉDICAS = '33'
export const PUBLICIDAD = '34'
export const GASTOS_DE_REPRESENTACIÓN = '35'
export const RETIRO_PARA_ENTREGA_A_TRABAJADORES = '36'
export const RETIRO_POR_CONVENIO_COLECTIVO = '37'
export const RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO = '38'
export const OTROS_1 = '91'
export const OTROS_2 = '92'
export const OTROS_3 = '93'
export const OTROS_4 = '94'
export const OTROS_5 = '95'
export const OTROS_6 = '96'
export const OTROS_7 = '97'
export const OTROS_8 = '98'
export const OTROS = '99'

export const __dictionary = {
  [VENTA_NACIONAL]: { id: VENTA_NACIONAL, nombre: `${VENTA_NACIONAL} - VENTA NACIONAL` },
  [COMPRA_NACIONAL]: { id: COMPRA_NACIONAL, nombre: `${COMPRA_NACIONAL} - COMPRA NACIONAL` },
  [CONSIGNACIÓN_RECIBIDA]: { id: CONSIGNACIÓN_RECIBIDA, nombre: `${CONSIGNACIÓN_RECIBIDA} - CONSIGNACIÓN RECIBIDA` },
  [CONSIGNACIÓN_ENTREGADA]: { id: CONSIGNACIÓN_ENTREGADA, nombre: `${CONSIGNACIÓN_ENTREGADA} - CONSIGNACIÓN ENTREGADA` },
  [DEVOLUCIÓN_RECIBIDA]: { id: DEVOLUCIÓN_RECIBIDA, nombre: `${DEVOLUCIÓN_RECIBIDA} - DEVOLUCIÓN RECIBIDA` },
  [DEVOLUCIÓN_ENTREGADA]: { id: DEVOLUCIÓN_ENTREGADA, nombre: `${DEVOLUCIÓN_ENTREGADA} - DEVOLUCIÓN ENTREGADA` },
  [BONIFICACIÓN]: { id: BONIFICACIÓN, nombre: `${BONIFICACIÓN} - BONIFICACIÓN` },
  [PREMIO]: { id: PREMIO, nombre: `${PREMIO} - PREMIO` },
  [DONACIÓN]: { id: DONACIÓN, nombre: `${DONACIÓN} - DONACIÓN` },
  [SALIDA_A_PRODUCCIÓN]: { id: SALIDA_A_PRODUCCIÓN, nombre: `${SALIDA_A_PRODUCCIÓN} - SALIDA A PRODUCCIÓN` },
  [SALIDA_POR_TRANSFERENCIA_ENTRE_ALMACENES]: {
    id: SALIDA_POR_TRANSFERENCIA_ENTRE_ALMACENES,
    nombre: `${SALIDA_POR_TRANSFERENCIA_ENTRE_ALMACENES} - SALIDA POR TRANSFERENCIA ENTRE ALMACENES`
  },
  [RETIRO]: { id: RETIRO, nombre: `${RETIRO} - RETIRO` },
  [MERMAS]: { id: MERMAS, nombre: `${MERMAS} - MERMAS` },
  [DESMEDROS]: { id: DESMEDROS, nombre: `${DESMEDROS} - DESMEDROS` },
  [DESTRUCCIÓN]: { id: DESTRUCCIÓN, nombre: `${DESTRUCCIÓN} - DESTRUCCIÓN` },
  [SALDO_INICIAL]: { id: SALDO_INICIAL, nombre: `${SALDO_INICIAL} - SALDO INICIAL` },
  [EXPORTACIÓN]: { id: EXPORTACIÓN, nombre: `${EXPORTACIÓN} - EXPORTACIÓN` },
  [IMPORTACIÓN]: { id: IMPORTACIÓN, nombre: `${IMPORTACIÓN} - IMPORTACIÓN` },
  [ENTRADA_DE_PRODUCCIÓN]: { id: ENTRADA_DE_PRODUCCIÓN, nombre: `${ENTRADA_DE_PRODUCCIÓN} - ENTRADA DE PRODUCCIÓN` },
  [ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN]: {
    id: ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN,
    nombre: `${ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN} - ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN`
  },
  [ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES]: {
    id: ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES,
    nombre: `${ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES} - ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES`
  },
  [ENTRADA_POR_IDENTIFICACIÓN_ERRONEA]: {
    id: ENTRADA_POR_IDENTIFICACIÓN_ERRONEA,
    nombre: `${ENTRADA_POR_IDENTIFICACIÓN_ERRONEA} - ENTRADA_POR_IDENTIFICACIÓN_ERRONEA`
  },
  [SALIDA_POR_IDENTIFICACIÓN_ERRONEA]: {
    id: SALIDA_POR_IDENTIFICACIÓN_ERRONEA,
    nombre: `${SALIDA_POR_IDENTIFICACIÓN_ERRONEA} - SALIDA_POR_IDENTIFICACIÓN_ERRONEA`
  },
  [ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE]: {
    id: ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE,
    nombre: `${ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE} - ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE`
  },
  [SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR]: {
    id: SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR,
    nombre: `${SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR} - SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR`
  },
  [ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN]: {
    id: ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN,
    nombre: `${ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN} - ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN`
  },
  [SALIDA_POR_SERVICIO_DE_PRODUCCIÓN]: {
    id: SALIDA_POR_SERVICIO_DE_PRODUCCIÓN,
    nombre: `${SALIDA_POR_SERVICIO_DE_PRODUCCIÓN} - SALIDA_POR_SERVICIO_DE_PRODUCCIÓN`
  },
  [AJUSTE_POR_DIFERENCIA_DE_INVENTARIO]: {
    id: AJUSTE_POR_DIFERENCIA_DE_INVENTARIO,
    nombre: `${AJUSTE_POR_DIFERENCIA_DE_INVENTARIO} - AJUSTE_POR_DIFERENCIA_DE_INVENTARIO`
  },
  [ENTRADA_DE_BIENES_EN_PRÉSTAMO]: { id: ENTRADA_DE_BIENES_EN_PRÉSTAMO, nombre: `${ENTRADA_DE_BIENES_EN_PRÉSTAMO} - ENTRADA_DE_BIENES_EN_PRÉSTAMO` },
  [SALIDA_DE_BIENES_EN_PRÉSTAMO]: { id: SALIDA_DE_BIENES_EN_PRÉSTAMO, nombre: `${SALIDA_DE_BIENES_EN_PRÉSTAMO} - SALIDA_DE_BIENES_EN_PRÉSTAMO` },
  [ENTRADA_DE_BIENES_EN_CUSTODIA]: { id: ENTRADA_DE_BIENES_EN_CUSTODIA, nombre: `${ENTRADA_DE_BIENES_EN_CUSTODIA} - ENTRADA_DE_BIENES_EN_CUSTODIA` },
  [SALIDA_DE_BIENES_EN_CUSTODIA]: { id: SALIDA_DE_BIENES_EN_CUSTODIA, nombre: `${SALIDA_DE_BIENES_EN_CUSTODIA} - SALIDA_DE_BIENES_EN_CUSTODIA` },
  [MUESTRAS_MÉDICAS]: { id: MUESTRAS_MÉDICAS, nombre: `${MUESTRAS_MÉDICAS} - MUESTRAS_MÉDICAS` },
  [PUBLICIDAD]: { id: PUBLICIDAD, nombre: `${PUBLICIDAD} - PUBLICIDAD` },
  [GASTOS_DE_REPRESENTACIÓN]: { id: GASTOS_DE_REPRESENTACIÓN, nombre: `${GASTOS_DE_REPRESENTACIÓN} - GASTOS_DE_REPRESENTACIÓN` },
  [RETIRO_PARA_ENTREGA_A_TRABAJADORES]: {
    id: RETIRO_PARA_ENTREGA_A_TRABAJADORES,
    nombre: `${RETIRO_PARA_ENTREGA_A_TRABAJADORES} - RETIRO_PARA_ENTREGA_A_TRABAJADORES`
  },
  [RETIRO_POR_CONVENIO_COLECTIVO]: { id: RETIRO_POR_CONVENIO_COLECTIVO, nombre: `${RETIRO_POR_CONVENIO_COLECTIVO} - RETIRO_POR_CONVENIO_COLECTIVO` },
  [RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO]: {
    id: RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO,
    nombre: `${RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO} - RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO`
  },
  [OTROS_1]: { id: OTROS_1, nombre: `${OTROS_1} - OTROS_1` },
  [OTROS_2]: { id: OTROS_2, nombre: `${OTROS_2} - OTROS_2` },
  [OTROS_3]: { id: OTROS_3, nombre: `${OTROS_3} - OTROS_3` },
  [OTROS_4]: { id: OTROS_4, nombre: `${OTROS_4} - OTROS_4` },
  [OTROS_5]: { id: OTROS_5, nombre: `${OTROS_5} - OTROS_5` },
  [OTROS_6]: { id: OTROS_6, nombre: `${OTROS_6} - OTROS_6` },
  [OTROS_7]: { id: OTROS_7, nombre: `${OTROS_7} - OTROS_7` },
  [OTROS_8]: { id: OTROS_8, nombre: `${OTROS_8} - OTROS_8` },
  [OTROS]: { id: OTROS, nombre: `${OTROS} - OTROS` }
}

export const __array = [
  __dictionary[VENTA_NACIONAL],
  __dictionary[COMPRA_NACIONAL],
  __dictionary[CONSIGNACIÓN_RECIBIDA],
  __dictionary[CONSIGNACIÓN_ENTREGADA],
  __dictionary[DEVOLUCIÓN_RECIBIDA],
  __dictionary[DEVOLUCIÓN_ENTREGADA],
  __dictionary[BONIFICACIÓN],
  __dictionary[PREMIO],
  __dictionary[DONACIÓN],
  __dictionary[SALIDA_A_PRODUCCIÓN],
  __dictionary[SALIDA_POR_TRANSFERENCIA_ENTRE_ALMACENES],
  __dictionary[RETIRO],
  __dictionary[MERMAS],
  __dictionary[DESMEDROS],
  __dictionary[DESTRUCCIÓN],
  __dictionary[SALDO_INICIAL],
  __dictionary[EXPORTACIÓN],
  __dictionary[IMPORTACIÓN],
  __dictionary[ENTRADA_DE_PRODUCCIÓN],
  __dictionary[ENTRADA_POR_DEVOLUCIÓN_DE_PRODUCCIÓN],
  __dictionary[ENTRADA_POR_TRANSFERENCIA_ENTRE_ALMACENES],
  __dictionary[ENTRADA_POR_IDENTIFICACIÓN_ERRONEA],
  __dictionary[SALIDA_POR_IDENTIFICACIÓN_ERRONEA],
  __dictionary[ENTRADA_POR_DEVOLUCIÓN_DEL_CLIENTE],
  __dictionary[SALIDA_POR_DEVOLUCIÓN_AL_PROVEEDOR],
  __dictionary[ENTRADA_PARA_SERVICIO_DE_PRODUCCIÓN],
  __dictionary[SALIDA_POR_SERVICIO_DE_PRODUCCIÓN],
  __dictionary[AJUSTE_POR_DIFERENCIA_DE_INVENTARIO],
  __dictionary[ENTRADA_DE_BIENES_EN_PRÉSTAMO],
  __dictionary[SALIDA_DE_BIENES_EN_PRÉSTAMO],
  __dictionary[ENTRADA_DE_BIENES_EN_CUSTODIA],
  __dictionary[SALIDA_DE_BIENES_EN_CUSTODIA],
  __dictionary[MUESTRAS_MÉDICAS],
  __dictionary[PUBLICIDAD],
  __dictionary[GASTOS_DE_REPRESENTACIÓN],
  __dictionary[RETIRO_PARA_ENTREGA_A_TRABAJADORES],
  __dictionary[RETIRO_POR_CONVENIO_COLECTIVO],
  __dictionary[RETIRO_POR_SUSTITUCIÓN_DE_BIEN_SINIESTRADO],
  __dictionary[OTROS_1],
  __dictionary[OTROS_2],
  __dictionary[OTROS_3],
  __dictionary[OTROS_4],
  __dictionary[OTROS_5],
  __dictionary[OTROS_6],
  __dictionary[OTROS_7],
  __dictionary[OTROS_8],
  __dictionary[OTROS]
]
